import { useEffect, useRef } from "react";

/**
 * A FAIXA DE ABAS DO CELULAR — deixa à vista a aba que está aberta.
 *
 * No celular o menu lateral vira uma faixa que rola de lado (ver o bloco
 * "CELULAR" no fim de src/styles.css). Quem entra por um link direto de uma
 * aba que está lá na ponta via a faixa começando no começo, sem enxergar onde
 * estava — parecia que nenhuma aba estava selecionada.
 *
 * Duas sutilezas que custaram tempo:
 *  • `pronto` (o estado do portão de acesso) precisa entrar nas dependências:
 *    enquanto o acesso não é liberado, o menu nem existe na tela, e o efeito
 *    rodava cedo demais, sem achar nada;
 *  • a conta se repete em `document.fonts.ready`, porque a largura das abas
 *    muda quando a fonte final carrega, e a primeira medida parava a faixa no
 *    meio do caminho.
 *
 * Em tela de mesa não faz nada: lá a faixa não rola.
 */
export function useFaixaDeAbas(abaAtiva: string, pronto: boolean) {
  const navRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (!pronto) return;
    const rolar = () =>
      navRef.current
        ?.querySelector(".nav-item.active")
        // `block: "nearest"` é o que impede a página inteira de pular junto.
        // Sem "smooth" de propósito: ao abrir, a faixa já tem de estar no
        // lugar — a animação parece defeito para quem acabou de entrar.
        ?.scrollIntoView({ inline: "center", block: "nearest" });
    rolar();
    document.fonts?.ready.then(rolar).catch(() => {});
  }, [abaAtiva, pronto]);

  return navRef;
}
